var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _require = require('@zillow/is-local-storage-supported'),
    isLocalStorageSupported = _require.isLocalStorageSupported;

/* Constants */


var HAS_SEEN_FILTER = '__Z:WOW:ONBOARDING:HAS_SEEN_FILTER__';
var HAS_SELLING_INTEREST = '__Z:WOW:ONBOARDING:HAS_SELLING_INTEREST__';
var HAS_SEEN_INTERSTITIAL = '__Z:WOW:ONBOARDING:HAS_SEEN_INTERSTITIAL__';
var PROPERTY_INTEREST_TYPE = '__Z:WOW:ONBOARDING:PROPERTY_INTEREST_TYPE__';
var DEFAULT_LISTING_TYPES = ['fr=0', 'fs=1', 'mmm=1', 'rs=0', 'ah=0'];
var SUPPORTED_SEARCH_COOKIE_VERSION = '6';

/**
 * Determines whether or not a user has been shown a filter
 * based on the state of their localStorage map (when supported).
 * @return {Boolean}
 */
var hasSeenFilterOnLand = function () {
    return isLocalStorageSupported() ? Boolean(global.window.localStorage.getItem(HAS_SEEN_FILTER)) : true;
};

/**
 * Sets HAS_SEEN_FILTER value in localStorage to 'true' (when supported).
 */
var setSeenFilterOnLand = function () {
    return isLocalStorageSupported() && global.window.localStorage.setItem(HAS_SEEN_FILTER, 'true');
};

/**
 * DEPRECATED
 * Determines whether or not a user has set interest in selling
 * based on the state of their localStorage map (when supported).
 * @return {Boolean}
 */
var hasSellingInterest = function () {
    return isLocalStorageSupported() && Boolean(global.window.localStorage.getItem(HAS_SELLING_INTEREST));
};

/**
 * DEPRECATED
 * Sets HAS_SELLING_INTEREST value in localStorage to 'true' (when supported).
 */
var setSellingInterest = function () {
    return isLocalStorageSupported() && global.window.localStorage.setItem(HAS_SELLING_INTEREST, 'true');
};

/**
 * Determines most recently set interest type
 * set via listing interstitial.
 * @return {String} 
 */
var getPropertyInterestType = function () {
    return isLocalStorageSupported() && global.window.localStorage.getItem(PROPERTY_INTEREST_TYPE);
};

/**
 * Sets interest type in local storage.
 * @param {String} type property type string
 */
var setPropertyInterestType = function (type) {
    return isLocalStorageSupported() && global.window.localStorage.setItem(PROPERTY_INTEREST_TYPE, type);
};

/**
 * Determines whether or not a user has seen the Listing type Interstitial
 * based on the state of their localStorage map (when supported).
 * @return {Boolean}
 */
var hasSeenInterstitial = function () {
    return isLocalStorageSupported() ? Boolean(global.window.localStorage.getItem(HAS_SEEN_INTERSTITIAL)) : true;
};

/**
 * Sets HAS_SEEN_INTERSTITIAL value in localStorage to 'true' (when supported).
 */
var setSeenInterstitial = function () {
    return isLocalStorageSupported() && global.window.localStorage.setItem(HAS_SEEN_INTERSTITIAL, 'true');
};

/**
 * Parses a search cookie, returning the string representing the filter state.
 * NOTE: this function was built to support version 6 of the search cookie.
 * https://bitbucket.zgtools.net/projects/SERVICES/repos/zillow-web/browse/src/main/java/com/zillow/web/cookies/SearchCookie.java?until=3499c230f92df8a767798a34816241c46c4937b0&untilPath=src%2Fmain%2Fjava%2Fcom%2Fzillow%2Fweb%2Fcookies%2FSearchCookie.java#27
 * @param {String} searchCookie
 * @return {String}
 */
var getFilterStateFromCookie = function (searchCookie) {
    if (!searchCookie || typeof searchCookie !== 'string') {
        console.error('The passed in \'searchCookie\' must be defined and must be a string. Instead received type: ' + (typeof searchCookie === 'undefined' ? 'undefined' : _typeof(searchCookie)) + '.');
        return '';
    }

    var searchCookieRegex = /^(\d+)\|\d+\|([^\t]+)/;
    // Based on how the cookie is encoded, it needs to be double-decoded to be readable

    var _decodeURIComponent$m = decodeURIComponent(decodeURI(searchCookie)).match(searchCookieRegex),
        version = _decodeURIComponent$m[1],
        searchFilter = _decodeURIComponent$m[2];

    if (version !== SUPPORTED_SEARCH_COOKIE_VERSION) {
        console.error('Expected version 6 of the search cookie. Instead received version ' + version + '.');
        return '';
    }

    return searchFilter || '';
};

/**
 * Determines if the search cookie contains listing type filters that differ from the default
 * listing type filters. If the search filter cannot be determined from the cookie, returns true.
 * @param {String} searchCookie users search cookie
 */
var hasListingTypeFilter = function (searchCookie) {
    var filterState = getFilterStateFromCookie(searchCookie);
    return filterState ? !DEFAULT_LISTING_TYPES.every(function (item) {
        return filterState.includes(item);
    }) : true;
};

/**
 * Determines if the search cookie contains a price filter. If the search filter cannot be
 * determined from the cookie, returns true.
 * @param {String} searchCookie users search cookie
 */
var hasPriceFilter = function (searchCookie) {
    return (/price|^$/.test(getFilterStateFromCookie(searchCookie))
    );
};

module.exports = {
    HAS_SEEN_FILTER: HAS_SEEN_FILTER,
    HAS_SEEN_INTERSTITIAL: HAS_SEEN_INTERSTITIAL,
    HAS_SELLING_INTEREST: HAS_SELLING_INTEREST,
    PROPERTY_INTEREST_TYPE: PROPERTY_INTEREST_TYPE,
    getFilterStateFromCookie: getFilterStateFromCookie,
    getPropertyInterestType: getPropertyInterestType,
    hasListingTypeFilter: hasListingTypeFilter,
    hasPriceFilter: hasPriceFilter,
    hasSeenFilterOnLand: hasSeenFilterOnLand,
    hasSeenInterstitial: hasSeenInterstitial,
    hasSellingInterest: hasSellingInterest,
    setPropertyInterestType: setPropertyInterestType,
    setSeenFilterOnLand: setSeenFilterOnLand,
    setSeenInterstitial: setSeenInterstitial,
    setSellingInterest: setSellingInterest
};
